import React from 'react';
import './App.css';
import Contacts from './components/Contacts';

function App() {
  return (
        <Contacts />
      
  );
}

export default App;
